import { render, staticRenderFns } from "./AreaRestaurantsListSectionModule.vue?vue&type=template&id=3067a722&"
import script from "./AreaRestaurantsListSectionModule.vue?vue&type=script&lang=js&"
export * from "./AreaRestaurantsListSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports